var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoxArrowUpRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 0.125V1.54167H10.4596L3.49667 8.50458L4.49542 9.50333L11.4583 2.54042V5.08333H12.875V0.125M11.4583 11.4583H1.54167V1.54167H6.5V0.125H1.54167C0.755417 0.125 0.125 0.7625 0.125 1.54167V11.4583C0.125 11.8341 0.274255 12.1944 0.539932 12.4601C0.805609 12.7257 1.16594 12.875 1.54167 12.875H11.4583C11.8341 12.875 12.1944 12.7257 12.4601 12.4601C12.7257 12.1944 12.875 11.8341 12.875 11.4583V6.5H11.4583V11.4583Z",
    fill: "#54595E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxArrowUpRight);
export default __webpack_public_path__ + "static/media/BoxArrowUpRight.9c17c43e.svg";
export { ForwardRef as ReactComponent };